
var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');

module.exports = /*@ngInject*/ ["$cookies", "$rootScope", "ConfigService", function ($cookies, $rootScope, ConfigService) {
    var factory = {};
    factory.currentUnitSystem;
    factory.previousUnitSystem;

    factory.currentLocale;
    factory.currentLocaleConfig;

    factory.locales = [{
        'name': 'en_US',
        'label': 'AMERICAN',
        'flag': 'us',
        'separator': ',',
        'decimalSeparator': '.'
    }, {
        'name': 'fr_FR',
        'label': 'FRENCH',
        'flag': 'fr',
        'separator': ';',
        'decimalSeparator': ','

    }, {
        'name': 'it_IT',
        'label': 'ITALIAN',
        'flag': 'it',
        'separator': ';',
        'decimalSeparator': ','
    }, {
        'name': 'de_AT',
        'label': 'Austrian',
        'flag': 'at',
        'separator': ';',
        'decimalSeparator': ','
    }, {
        'name': 'nl_BE',
        'label': 'BELGIAN',
        'flag': 'be',
        'separator': ';',
        'decimalSeparator': ','
    }];

    factory.getCurrentLocaleConfig = function () {
        return factory.getLocaleConfig(factory.currentLocale);
    };

    factory.getLocaleConfig = function (localeName) {
        var found = arrayUtil.getFirstInList(factory.locales, "name", localeName);
        return util.isDefined(found) ? found : arrayUtil.getFirstInList(factory.locales, "name", 'fr_FR');
    };

    factory.getConfiguredLocales = function () {
        return angular.copy(factory.locales);
    };

    $rootScope.$on("unitsChanged", function () {
        factory.previousUnitSystem = factory.currentUnitSystem;
        factory.currentUnitSystem = factory.getUnitSystem();
    });

    $rootScope.$on("localeChanged", function () {
        factory.getLocale(true);
        factory.currentLocaleConfig = factory.getLocaleConfig(factory.currentLocale);
    });

    factory.getCurrencySymbol = function (currency) {
        if (arguments.length === 0) {
            currency = $cookies.get('nomad.noc.ng.currency');
        }
        return {
            'usd': '$',
            'cad': '$',
            'gbp': '£',
            'eur': '€',
            'dkk': 'kr',
            'sek': 'kr',
            'inr': '₹'
        }[currency] || '€';
    };

    factory.convertSpeed = function (kmh) {
        if (!factory.isMetric()) {
            return factory.toMilesPerHour(kmh);
        } else {
            return kmh;
        }
    };

    factory.isMetric = function () {
        if (!util.isDefined(factory.currentUnitSystem)) {
            factory.currentUnitSystem = factory.getUnitSystem();
            factory.previousUnitSystem = undefined;
        }
        return factory.currentUnitSystem === 'metric';
    };

    factory.isUnitSystem = function (system) {
        return getUnitFromCookie() === system;
    };

    factory.getUnitSystem = function () {
        var units = $cookies.get('nomad.noc.ng.units');
        if (util.isDefined(units)) {
            return units;
        } else {
            return '';
        }
    };

    factory.toMilesPerHour = function (kmh) {
        return kmh / 1.61;
    };


    factory.getLocale = function (forceRenew) {
        if (util.isTrue(forceRenew) || !util.isDefined(factory.currentLocale)) {
            factory.currentLocale = $cookies.get('nomad.noc.ng.locale');
            if (!util.isDefined(factory.currentLocale)) {
                factory.currentLocale = "fr_FR";
                $cookies.put("nomad.noc.ng.locale", factory.currentLocale, {secure: ConfigService.get('secureCookies')});
            }
        }
        return factory.currentLocale;
    };

    factory.getCurrentLocale = function () {
        return factory.currentLocale;
    };

    factory.formatCSVValue = function (value) {
        var toStr = "" + value;
        if (factory.currentLocaleConfig.decimalSeparator === "," && util.containsText(toStr, ".")) {
            toStr = toStr.replace(".", ",");
        }
        return toStr;
    };

    return factory;
}];
